export default __webpack_public_path__ + "static/media/logo-fb.d1c3f3a6.svg";